__turbopack_context__.v({
  "className": "rubik_4ff90a24-module__iZD67W__className",
});
